import { MobileCampaign } from '@/mobile/types/api/mypage/campaign';

/**
 * 「キャンペーン内容」の表示／非表示を情報を取得する。(mobile用)
 * @param campaignInfo キャンペーン情報
 * @returns 表示可能な場合は、trueを返却する。それ以外は、falseを返却する。
 */
const isShowCampaign = (campaignInfo: MobileCampaign): boolean => {
  if (!campaignInfo) {
    return false;
  }

  // キャンペーン本体かキャッシュバックのどちらか一方でも存在すれば、詳細導線を表示できるようにする。
  if (campaignInfo?.campaigns?.length >= 1) {
    return true;
  }
  // API によってはキャッシュバックだけ返るため、campaigns が空でもここで表示可と判定する。
  if (campaignInfo?.cashbacks?.length >= 1) {
    return true;
  }
  return false;
};

export default isShowCampaign;
